import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { LocalidadeService } from '../localidade/localidade.service';

@Component({
  selector: 'ntc-logradouro',
  templateUrl: './logradouro.component.html',
  styleUrls: ['./logradouro.component.css']
})
export class LogradouroComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  editOptionsGridLogradouro = null;
  colunasGridLogradouro = null;
  logradouro = null;
  listaLocalidade = null;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  constructor(
    @Inject(Http) http: Http,
    private localidadeService: LocalidadeService
  ) {
    this.logradouro = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/logradouro/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/logradouro/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/logradouro/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/logradouro/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridLogradouro = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'NomeLogradouro',
        dataType: 'string',
        caption: 'Nome do Logradouro',
        validationRules: [{
          type: 'required',
          message: 'Nome do logradouro é obrigatório.'
        }]
      }
    ];

    this.editOptionsGridLogradouro = {
      mode: GridConfig.gridMode, // form GridConfig.gridMode
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Logradouro',
        showTitle: true
      }
    };
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit(
  ) {
    this.alturaGrid = calculaAlturaGrid();
    this.localidadeService.getLocalidades().subscribe(localidade => {
      this.listaLocalidade = localidade;

      const selectLocalidade = {
        dataField: 'IdLocalidade',
        caption: 'Localidade',
        lookup: {
            dataSource: this.listaLocalidade,
            displayExpr: 'NomeLocalidade',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Localidade é obrigatória.'
        }]
      };

      this.colunasGridLogradouro.push(selectLocalidade);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/logradouro/logradouro.component.ts